export default {
  name: "HeroSection",

  data() {
    return ({
      hero_data: {
        kicker: "Empire Partner Foundation",
        headline: "Building a",
        headline_line_2: "Perpetual",
        headline_accent: "Social Legacy",
        sub_headline:
          "Move from charity to sustainable production. Your donation enters a perpetual engine — it buys an asset, generates revenue, and a portion of profits recycles back to fund the next entrepreneur.",
        btn_text: "Adopt an Asset",
        demo_text: "How it Works",
        primary_btn_link: "/adopt",
        secondary_btn_link: "#how",
        background_image:
          "https://empirewebvideos.s3.us-east-1.amazonaws.com/Probabase_bolide/envato-labs-image-edit+(1).png",
      },

      hero_stats: [
        { key: "youth_unemployment", value: "46.1%", label: "Youth Unemployment" },
        { key: "job_cost", value: "R1,000", label: "Per Verified Job Created" },
        { key: "deductible", value: "100%", label: "Section 18A Deductible" },
      ],
    });
  },
};
